/**
 * Shared Sentry helpers (plain JS so `instrumentation.server.mjs` can import them).
 * Keep SENTRY_FALLBACK_DSN in sync with production if you rotate projects.
 */
const SENTRY_FALLBACK_DSN =
  "https://a92640ae269327e322c9304c7ca9951a@o4508204123291648.ingest.us.sentry.io/4508204125716480";

export function resolveSentryDsn() {
  const fromEnv =
    typeof process !== "undefined" && process.env && process.env.SENTRY_DSN;
  const dsn = typeof fromEnv === "string" ? fromEnv.trim() : "";
  return dsn.length > 0 ? dsn : SENTRY_FALLBACK_DSN;
}

export function resolveTracesSampleRate() {
  const raw =
    typeof process !== "undefined" &&
    process.env &&
    process.env.SENTRY_TRACES_SAMPLE_RATE;
  if (typeof raw === "string" && raw.trim() !== "") {
    const n = Number(raw.trim());
    if (Number.isFinite(n)) return Math.min(1, Math.max(0, n));
  }
  const prod =
    typeof process !== "undefined" &&
    process.env &&
    process.env.NODE_ENV === "production";
  return prod ? 0.1 : 1;
}

/** Drop expected Remix route / HTTP client errors (404, 403, etc.). */
function httpStatusFromException(error) {
  if (error == null || typeof error !== "object") return null;
  if (typeof error.status === "number") return error.status;
  if (typeof error.statusCode === "number") return error.statusCode;
  return null;
}

/**
 * @param {import('@sentry/core').ErrorEvent} event
 * @param {{ originalException?: unknown }} hint
 */
export function sentryBeforeSend(event, hint) {
  const original = hint?.originalException;
  if (original instanceof Response && original.status < 500) {
    return null;
  }
  const status = httpStatusFromException(original);
  if (status != null && status > 0 && status < 500) {
    return null;
  }
  return event;
}
